import ClientAnalysisEntity from "../../domain/entities/client_analysis.entity";

const fromJSON = (json: any): ClientAnalysisEntity => {
    return {
        agentId: json.id,
        agentName: json.name,
        calification: json.avg_score,
        audios: json.calls_evaluated_detail.map((call: any) => {
            return {
                name: call.audio_name,
                score: call.score,
                jobId: call.job_id,
            }
        }),
        agentInternalId: json.internal_id,
        content: json.feedback,
    }
}

const ClientAnalysisDto = {
    fromJSON
}

export default ClientAnalysisDto;